import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PunteggioRoutingModule } from './punteggio-routing.module';
import { PunteggioComponent } from './punteggio.component';


@NgModule({
  declarations: [PunteggioComponent],
  imports: [
    CommonModule,
    PunteggioRoutingModule
  ]
})
export class PunteggioModule { }
